import { faCalendarXmark } from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const RescheduleButton = ({ session }: { session: SessionBooking }) => {
  const { handleReschedule, showResheduleButton } = useSession(session)
  const { isClientOfOtherCoach } = useUserRole()

  if (!showResheduleButton) return <></>

  return (
    <Button
      text="Reschedule"
      buttonType="secondary"
      onClick={handleReschedule}
      icon={faCalendarXmark}
      disabled={isClientOfOtherCoach}
    />
  )
}

export default RescheduleButton
